export const DEFAULT_PACKAGES = [
  { id: "wifi-3-days", name: "3 Days", price: 10, durationDays: 3, devices: 1, portal: "standard" },
  { id: "wifi-14-days", name: "14 Days", price: 39, durationDays: 14, devices: 1, portal: "standard" },
  { id: "wifi-30-days", name: "30 Days", price: 75, durationDays: 30, devices: 1, portal: "standard" },
  { id: "wifi-30-days-2-devices", name: "30 Days", price: 140, durationDays: 30, devices: 2, portal: "standard" },
];

export const MIGRATION_PACKAGES = [
  { id: "Immigration-32d", name: "Immigration", price: 100, durationDays: 32, devices: 3, portal: "migration" },
  { id: "Custom-32d", name: "Custom", price: 100, durationDays: 32, devices: 3, portal: "migration" },
  { id: "Police-32d", name: "Police", price: 100, durationDays: 32, devices: 3, portal: "migration" },
];

export const LEGACY_PACKAGE_IDS = MIGRATION_PACKAGES.map((pkg) => pkg.id);

export const formatPackageDuration = (pkg) => {
  const durationHours = Number(pkg?.durationHours);
  if (Number.isInteger(durationHours) && durationHours > 0) {
    return `${durationHours} hour${durationHours === 1 ? "" : "s"}`;
  }

  const durationDays = Number(pkg?.durationDays);
  if (Number.isInteger(durationDays) && durationDays > 0) {
    return `${durationDays} day${durationDays === 1 ? "" : "s"}`;
  }

  return "";
};

export const mergePackages = (savedPackages = [], { includeInactive = false } = {}) => {
  const defaults = [...DEFAULT_PACKAGES, ...MIGRATION_PACKAGES];
  const savedById = new Map(savedPackages.map((pkg) => [pkg.id, pkg]));
  const merged = defaults.map((pkg) => ({
    ...pkg,
    ...(savedById.get(pkg.id) || {}),
    active: savedById.get(pkg.id)?.active !== false,
  }));

  savedPackages.forEach((pkg) => {
    if (!merged.some((item) => item.id === pkg.id)) {
      merged.push({
        ...pkg,
        active: pkg.active !== false,
        portal: pkg.portal === "migration" ? "migration" : "standard",
      });
    }
  });

  return includeInactive ? merged : merged.filter((pkg) => pkg.active);
};
